// extracted by mini-css-extract-plugin
export default {"selector":"RoleSelector_selector__FFRhk","text":"RoleSelector_text__yx7X7","arrow":"RoleSelector_arrow__OVl4b","arrow-routed":"RoleSelector_arrow-routed__5WvUD"};